"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var HeaderFlexPane_1 = require("./HeaderFlexPane");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var mobx_react_1 = require("mobx-react");
var owa_uservoice_1 = require("owa-uservoice");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var owa_workloads_1 = require("owa-workloads");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var owa_help_charm_1 = require("owa-help-charm");
var styles = require('./HeaderPane.scss');
// TODO: Task 659 -- Provide context-sensitive help divs
var Helpdiv = 'https://go.microsoft.com/fwlink/?linkid=853225';
var Privacydiv = 'https://go.microsoft.com/fwlink/?linkId=521839';
var Termsdiv = 'https://www.microsoft.com/en-us/servicesagreement';
var feedbackTitle = 'New feedback from Outlook.com (React)';
var consumerForumId = 601444;
var enterpriseForumId = 907141;
var HelpPane = /** @class */ (function (_super) {
    tslib_1.__extends(HelpPane, _super);
    function HelpPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openHelpTab = function () {
            window.open(Helpdiv, '_blank');
        };
        _this.openPrivacyTab = function () {
            window.open(Privacydiv, '_blank');
        };
        _this.openTermsTab = function () {
            window.open(Termsdiv, '_blank');
        };
        _this.launchInAppFeedback = function () {
            var isConsumer = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
            owa_uservoice_1.showUserVoiceSuggestionDialog({
                title: feedbackTitle,
                feedbackType: 0 /* Feedback */,
                blurb: owa_common_strings_1.default.userVoiceExplanation,
                userVoiceForumId: isConsumer ? consumerForumId : enterpriseForumId,
            });
        };
        _this.onPaneDismiss = function () {
            owa_help_charm_1.destroyWidgetOnPaneDismiss();
            _this.props.onDismiss();
        };
        return _this;
    }
    HelpPane.prototype.render = function () {
        var _this = this;
        var isMiniMavenWidgetEnabled = owa_mail_feature_flags_1.isMailFeatureEnabled('help-miniMavenWidget');
        if (isMiniMavenWidgetEnabled) {
            owa_help_charm_1.sendMiniMavenDataPoint({
                sessionId: '',
                eventId: 'HelpPaneRendered',
                eventData: 'Owa Mail',
                loadTime: '',
                isDeeplinkScenario: '',
            });
        }
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_common_strings_1.default.helpCharm_ariaLabel; }, content: React.createElement("div", null,
                isMiniMavenWidgetEnabled && (React.createElement("div", { className: styles.miniMavenWidget },
                    React.createElement("div", { ref: function (ref) { return owa_help_charm_1.loadMiniMavenHelpWidget(ref, _this.onPaneDismiss); } },
                        React.createElement(Spinner_1.Spinner, { className: styles.miniMavenWidgetLoading })))),
                React.createElement("div", { className: styles.actionsDiv },
                    React.createElement("ul", { className: styles.actions },
                        React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.launchInAppFeedback, text: owa_common_strings_1.default.feedbackLink, className: styles.action })),
                        !isMiniMavenWidgetEnabled && (React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.openHelpTab, text: owa_common_strings_1.default.helpLink, className: styles.action }))),
                        React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.openPrivacyTab, text: owa_common_strings_1.default.privacyLink, className: styles.action })),
                        React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.openTermsTab, text: owa_common_strings_1.default.termsLink, className: styles.action })),
                        owa_workloads_1.isWorkloadSupported(2 /* Calendar */) && (React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { href: "https://www.microsoft.com/concern/calendarabuse", text: owa_common_strings_1.default.reportCalendarAbuseLink, className: styles.action })))))), onDismiss: isMiniMavenWidgetEnabled ? this.onPaneDismiss : this.props.onDismiss }));
    };
    HelpPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], HelpPane);
    return HelpPane;
}(React.Component));
exports.default = HelpPane;
//# sourceMappingURL=HelpPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/HelpPane.js
// module id = 6206
// module chunks = 38